(() => {
  if (window.CYSMobileProductLoaded) return;
  window.CYSMobileProductLoaded = true;

  const moneyTextFromProduct = (sectionId) => {
    const priceRoot = document.getElementById(`price-${sectionId}`);
    if (!priceRoot) return '';

    const sale = priceRoot.querySelector('.price--on-sale .price-item--sale, .price__sale .price-item--sale');
    if (sale && sale.textContent.trim()) return sale.textContent.trim();

    const regular = priceRoot.querySelector('.price__regular .price-item--regular, .price-item--regular');
    return regular?.textContent.trim() || '';
  };

  const formatVariant = (optionNames, variant) => {
    if (!variant?.options?.length) return '';

    return variant.options
      .map((value, index) => {
        if (!value || value === 'Default Title') return '';
        const name = optionNames[index] || '';
        return `${name} ${value}`.trim();
      })
      .filter(Boolean)
      .join(' · ');
  };

  const initStickyBar = (bar) => {
    const sectionId = bar.dataset.sectionId;
    const mainButton = document.getElementById(bar.dataset.mainButtonId);
    const submit = bar.querySelector('[data-cys-sticky-submit]');
    const variantText = bar.querySelector('[data-cys-sticky-variant]');
    const priceText = bar.querySelector('[data-cys-sticky-price]');
    const optionsJson = bar.querySelector('[data-cys-sticky-option-names]');

    if (!mainButton || !submit) return;

    let optionNames = [];
    try {
      optionNames = JSON.parse(optionsJson?.textContent || '[]');
    } catch (_) {
      optionNames = [];
    }

    let ticking = false;
    const updateVisibility = () => {
      ticking = false;
      if (!window.matchMedia('(max-width: 749px)').matches) {
        bar.hidden = true;
        return;
      }

      const rect = mainButton.closest('.product-form__buttons')?.getBoundingClientRect() || mainButton.getBoundingClientRect();
      bar.hidden = !(rect.bottom < 0);
    };

    const requestVisibilityUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    };

    submit.addEventListener('click', () => {
      if (submit.disabled || mainButton.disabled) return;
      mainButton.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (String(event?.data?.sectionId) !== String(sectionId)) return;

        const variant = event?.data?.variant;
        if (variantText) variantText.textContent = formatVariant(optionNames, variant);

        const available = Boolean(variant?.available);
        submit.disabled = !available;
        submit.textContent = !variant ? 'Unavailable' : available ? 'Add to cart' : 'Sold out';

        window.setTimeout(() => {
          const currentPrice = moneyTextFromProduct(sectionId);
          if (priceText && currentPrice) priceText.textContent = currentPrice;
        }, 0);
      });
    }

    const syncFromMainButton = () => {
      submit.disabled = mainButton.disabled;
      if (mainButton.disabled) {
        const text = mainButton.textContent.trim().toLowerCase();
        submit.textContent = text.includes('sold') ? 'Sold out' : 'Unavailable';
      } else {
        submit.textContent = 'Add to cart';
      }
    };

    const observer = new MutationObserver(syncFromMainButton);
    observer.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
    window.addEventListener('orientationchange', requestVisibilityUpdate, { passive: true });

    syncFromMainButton();
    updateVisibility();
  };

  const init = () => {
    document.querySelectorAll('[data-cys-sticky-atc]').forEach(initStickyBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
